// Copyright © 2026 Spicy Friends

import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/intro')({
  loader: () => {
    throw redirect({ to: '/', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
